
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import CheckBox from "@/components/Checkbox.vue";

export default {
    name: "RGPDPopin",
    components: {
        CheckBox: CheckBox
    },
    emits: ["close"],
    props: {
        emailConsent: {
            type: Boolean,
            default: true
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n({ useScope: "global" });
        const shareEmailConsent = ref(false);
        const termsAndConditionsConsent = ref(false);
        const checkboxBgColor = ref("#D2D2D2");
        const checkboxFgColor = ref("#000000");

        const error = ref("");

        async function submitForm() {
            if (!termsAndConditionsConsent.value) {
                error.value = t("rgpd.error.termsAndConditionsCheckboxRequired");
            } else {
                error.value = "";

                try {
                    emit("close", {
                        termsAndConditionsConsent: termsAndConditionsConsent.value,
                        shareEmailConsent: props.emailConsent ? shareEmailConsent.value : undefined
                    });
                } catch {
                    error.value = "An error occured";
                }
            }
        }

        function acceptAll() {
            termsAndConditionsConsent.value = true;
            shareEmailConsent.value = true;
        }

        function rejectAll() {
            termsAndConditionsConsent.value = false;
            shareEmailConsent.value = false;

            submitForm();
        }

        return {
            submitForm,
            acceptAll,
            rejectAll,
            shareEmailConsent,
            termsAndConditionsConsent,
            error,
            checkboxBgColor,
            checkboxFgColor
        };
    }
};
